import {useUserSessionContext} from '../contexts';
import {Permission} from '../types';

export const usePermissionAccess = (permission: Permission) => {
  const {permissionsAccesses} = useUserSessionContext();

  return permissionsAccesses.find(permissionAccess => permissionAccess.permission === permission);
};
